export default "__VITE_ASSET__qqprZONn__"